<template>
    <div class="row">
        <label class="col-xl-3"></label>
        <div class="col-lg-9 col-xl-6">
            <h3 class="kt-section__title kt-section__title-sm"><slot></slot></h3>
        </div>
    </div>
</template>
